module.exports = __webpack_public_path__ + "img/straightFlush.fccd51a1.png";